export default __webpack_public_path__ + "4d722b7fbec5b2b316a4ad4041a1133c.svg";